import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import AppLayout from "../../Components/AppLayout";
import AuthLayout from "../../Components/AuthLayout";
import KenLoader from "../../GlobalComponents/KenLoader";
import {
  getAxiosInstance,
  getPlayerRegestrationWindow,
} from "../../Utils/apiService";

import routes from "../../Utils/routes";
import { PrivateRoute, PublicRoute } from "../../Utils/helperFunctions";
import StaffRegistration from "../StaffRegistration";
import ChooseExpertise from "../ChooseExpertise";
import Layout from "../../Components/Layout";
// import ContactSuccess from "../Auth/ContactSuccess";

// auth
const RegistrationNumBer = React.lazy(
  () => import("../Auth/RegistrationNumber/index")
);
const Login = React.lazy(() => import("../Auth/Login/index"));
const OtpVerify = React.lazy(() => import("../Auth/VerifyOtp"));
const ContactUs = React.lazy(() => import("../Auth/ContactUs"));
// home
const Home = React.lazy(() => import("../Home/index"));
const Launcher = React.lazy(() => import("../Launcher"));
const Splash = React.lazy(() => import("../Splash"));
const ThankYou = React.lazy(() => import("../ThankYou"));
const Closed = React.lazy(() => import("../Closed"));
const ContactSuccess = React.lazy(() => import("../Auth/ContactSuccess"));

// register
const Register = React.lazy(() => import("../Register"));

//Not Found

const MainLayout: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAxiosInstance();
    setLoading(false);
  }, []);

  return loading ? (
    <KenLoader />
  ) : (
    <>
      <Routes>
        {/* Initial Route */}
        <Route path="/" element={<Navigate to={routes.launcher} />} />

        {/* Public Routes */}
        <Route
          path={routes.registrationNumber}
          index
          element={
            <PublicRoute>
              <AuthLayout>
                <RegistrationNumBer />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.login}
          index
          element={
            <PublicRoute>
              <AuthLayout>
                <Login />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.otpverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <OtpVerify />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.register}
          index
          element={
            <PrivateRoute>
              <Layout>
                <Register />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.chooseExpertise}
          index
          element={
            <PrivateRoute>
              <Layout>
                <ChooseExpertise />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.physio}
          index
          element={
            <PrivateRoute>
              <Layout>
                <StaffRegistration />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.analyst}
          index
          element={
            <PrivateRoute>
              <Layout>
                <StaffRegistration />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.coach}
          index
          element={
            <PrivateRoute>
              <Layout>
                <StaffRegistration />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.masseur}
          index
          element={
            <PrivateRoute>
              <Layout>
                <StaffRegistration />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.snc}
          index
          element={
            <PrivateRoute>
              <Layout>
                <StaffRegistration />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.contactSuccess}
          element={
            <PublicRoute>
              <AuthLayout>
                <ContactSuccess />
              </AuthLayout>
            </PublicRoute>
          }
        />

        <Route
          path={routes.launcher}
          element={
            <AuthLayout>
              <Launcher />
            </AuthLayout>
          }
        />

        <Route
          path={routes.thankYou}
          element={
            <PrivateRoute>
              <Layout>
                <ThankYou />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.contactUs}
          element={
            <PublicRoute>
              <AuthLayout>
                <ContactUs />
              </AuthLayout>
            </PublicRoute>
          }
        />

        <Route
          path="*"
          element={
            <PublicRoute>
              <AuthLayout>
                <Login />
              </AuthLayout>
            </PublicRoute>
          }
        />
      </Routes>
    </>
  );
};

export default MainLayout;
